import { BaseAPI } from './base_api';

class CreditsAPI extends BaseAPI {
  async reportUsage(amount: number, projectId: number, api: string) {
    return this.postJSON('record_usage', { api, projectId, amount });
  }
}

export default new CreditsAPI('credit');
